const COPY = {
  en: {
    title: 'Make your own podcast',
    subtitle:
      'Now it’s easy to get heard on Spotify with our free podcast creation app, Anchor.',
    description: 'Join the world’s #1 podcasting platform.',
    valueProps: [
      {
        headline: 'A match made in podcast heaven',
        paragraphs: [
          'We recently welcomed Anchor to the Spotify family to make it easier for anyone to make a podcast, for free.',
        ],
        image: 'spotify-create',
      },
      {
        headline: 'Do it all, right from your phone',
        paragraphs: [
          'The Anchor app features 100% free high-quality creation tools like recording, editing, background music, and voice messaging.',
        ],
        image: 'anchor',
      },
      {
        headline: 'Get heard on Spotify',
        paragraphs: [
          'With just one tap, your show will be available on Spotify, Apple Podcasts, Google Podcasts, and all other major listening platforms.',
          'We can’t wait to hear your podcast.',
        ],
        image: 'spotify',
      },
    ],
  },
  br: {
    title: 'Faça o seu próprio podcast.',
    subtitle:
      'Agora é fácil ser encontrado no Spotify, basta usar o nosso novo aplicativo de criação de podcast, o Anchor.',
    description:
      'Junte-se à <strong>Dissect</strong> e a muitos outros na plataforma de podcasting nº 1 do mundo.',
    valueProps: [
      {
        headline: 'Um encontro no paraíso do podcast',
        paragraphs: [
          'Recentemente, para facilitar a criação de um podcast gratuitamente, recebemos a Anchor na família Spotify.',
        ],
        image: 'spotify-create',
      },
      {
        headline: 'Faça tudo, direto do seu telefone',
        paragraphs: [
          'O aplicativo Anchor oferece ferramentas gratuitas de criação de alta qualidade, como gravação, edição, música de fundo e mensagens de voz.',
        ],
        image: 'anchor',
      },
      {
        headline: 'Fique disponível no Spotify',
        paragraphs: [
          'Com apenas um toque, o seu programa estará disponível no Spotify, no Apple Podcasts, no Google Podcasts e em todas as outras principais plataformas de escuta.',
          'Estamos ansiosos para ouvir seu podcast.',
        ],
        image: 'spotify',
      },
    ],
  },
};

module.exports = {
  ASSET_CDN: 'https://d12xoj7p9moygp.cloudfront.net/',
  ASSET_PATH: 'images/screens/getonspotify/',
  FACEBOOK_SOCIAL_IMAGE:
    'https://d12xoj7p9moygp.cloudfront.net/images/social/getonspotify.png',
  TWITTER_SOCIAL_IMAGE:
    'https://d12xoj7p9moygp.cloudfront.net/images/social/getonspotify.png',
  COPY,
};
